


export const LOGINDATAREQUEST = "LOGINDATAREQUEST"
export const LOGINDATASUCCESS = "LOGINDATASUCCESS"
export const LOGINDATAFALIURE = "LOGINDATAFALIURE"